module.exports = __webpack_public_path__ + "img/works_subway_mobile_app_3.6992c7d7.png";